export default __webpack_public_path__ + "appointments/static/media/hazel.4b7e494b.png";